/*
#####################
## CustomScrollBar ##
#####################
Customizable ScrollBar. Library implemented: https://github.com/malte-wessel/react-custom-scrollbars

* OPTIONS
    * width[String]. Default: "95%". Optional.
    * height[String]. Default: "500". Optional.
    * border[String]. Default: "1px solid #CCC". Optional.

* EXAMPLE
    <CustomScrollBar
        width="100%"
        height="250"
    >
        <FormattedText value="documentation-default" />
    </CustomScrollBar>

*/

require('../../styles/blocks/_scroll.scss');

const React = require('react');
const PropTypes = require('prop-types');

const { Scrollbars } = require('react-custom-scrollbars');

class CustomScrollBar extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            height: null,
        };

        this.renderView = this.renderView.bind(this);
        this.renderThumb = this.renderThumb.bind(this);
        this.renderTrack = this.renderTrack.bind(this);
        this.renderThumbHorizontal = this.renderThumbHorizontal.bind(this);
    }

    UNSAFE_componentWillMount() {
        if (window.innerHeight <= 568) {
            this.setState({
                height: 201,
            });
        }
    }

    renderView() {
        return <div className="scroll-area" />;
    }

    renderThumb() {
        return <div className="scroll-bar-thumb" />;
    }

    renderTrack() {
        return <div className="scroll-bar-track" />;
    }

    renderThumbHorizontal() {
        return <div />;
    }

    render() {
        const { width, autoHeightMin } = this.props;
        let height;
        if (this.state.height) {
            height = this.state.height + 'px';
        } else {
            height = autoHeightMin;
        }

        return (
            <div
                className="custom-scroll-bar"
                style={{
                    width: width,
                    border: 0,
                }}
            >
                <Scrollbars
                    renderView={this.renderView}
                    renderThumbVertical={this.renderThumb}
                    renderTrackVertical={this.renderTrack}
                    renderThumbHorizontal={this.renderThumbHorizontal}
                    autoHeight
                    style={{
                        width: width,
                        margin: 'auto',
                    }}
                    {...this.props}
                    autoHeightMax={height}
                />
            </div>
        );
    }
}

CustomScrollBar.propTypes = {
    width: PropTypes.string,
    autoHeightMin: PropTypes.number,
};

CustomScrollBar.defaultProps = {
    width: 'auto',
    autoHeightMin: 200,
};

module.exports = CustomScrollBar;
